import { render, staticRenderFns } from "./FakeProgressbar.vue?vue&type=template&id=5afddbf8&scoped=true"
import script from "./FakeProgressbar.vue?vue&type=script&lang=js"
export * from "./FakeProgressbar.vue?vue&type=script&lang=js"
import style0 from "./FakeProgressbar.vue?vue&type=style&index=0&id=5afddbf8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5afddbf8",
  null
  
)

export default component.exports